export const HEALTHCHECK = 'healthcheck';
export const INFO = 'info';
export const ADMIN = 'admin';
export const ADOPTION = 'adoption';
export const ANCESTRY_RECORD = 'ancestry-record';
export const ANSWER = 'answer';
export const APPOINTMENT = 'appointment';
export const AUTH = 'auth';
export const AUTH_ADMIN_PANEL = 'auth/admin/authorization';
export const AUTH_CONTROL_PANEL = 'auth/control/authorization';
export const AUTH_QUESTIONNAIRE_KIOSK = 'auth/questionnaire/kiosk';
export const BRANDING_FILE = 'branding-file';
export const BREAST_RECORD = 'breast-record';
export const BREAST_TUMOR_RECORD = 'breast-tumor-record';
export const CANCER_DETAILS_RECORD = 'cancer-details-record';
export const DASHBOARD_BRANDING_RECORD = 'dashboard-branding-record';
export const DOWNLOAD = 'download';
export const FAMILY = 'family';
export const FAMILY_LINK = 'family-link';
export const FHQ_BRANDING_RECORD = 'fhq-branding-record';
export const FHQ_GENERAL_SETTING = 'fhq-general-settings-record';
export const FHQ_HELP_CONTACT = 'fhq-help-contact';
export const FHQ_SMS_EMAIL_INVITATION = 'fhq-sms-email-invitations';
export const FHQ_TEMPLATE = 'fhq-template';
export const FHQ_USERS = 'site-fhq-user';
export const FILE = 'file';
export const GENE_VARIANT = 'gene-variant';
export const GENETIC_TESTING_RECORD = 'genetic-testing-record';
export const GLOSSARY = 'glossary';
export const HIGHLIGHTER = 'highlighter';
export const INDIVIDUAL = 'individual';
export const INDIVIDUAL_ATTRIBUTE = 'individual-attribute';
export const INDIVIDUAL_AUTH = 'individual-auth';
export const INDIVIDUAL_BREAST_CANCER = 'individual-breast-cancer';
export const INDIVIDUAL_CANCER_SYMBOL = 'individual-cancer-symbol';
export const INDIVIDUAL_CANCER_TYPE = 'individual-cancer-type';
export const INDIVIDUAL_FHQ = 'individual-fhq';
export const INDIVIDUAL_INSURANCE = 'individual-insurance';
export const INDIVIDUAL_LYNCH_SYNDROME_MARKER = 'individual-lynch-syndrome-marker';
export const INDIVIDUAL_METADATA = 'individual-metadata';
export const INDIVIDUAL_OTHER_POLYP = 'individual-other-polyp';
export const INDIVIDUAL_PROBAND = `${INDIVIDUAL}/proband`;
export const INDIVIDUAL_SKIN_FINDING = 'individual-skin-finding';
export const IP_WHITELIST_RECORD = 'ip-whitelist-record';
export const LAB = 'lab';
export const LYNCH_SYNDROME_RECORD = 'lynch-syndrome-record';
export const MEASUREMENTS_RECORD = 'measurements-record';
export const NOTES = 'notes';
export const NOTIFICATION = 'notification';
export const NOTIFICATION_RULES = 'notification-rules-record';
export const ORGANIZATION = 'organization';
export const ORGANIZATION_FHQ = 'organization-fhq';
export const ORGANIZATION_SECURITY_SETTING = 'organization-security-setting';
export const OTHER_MEDICAL_RECORD = 'other-medical-record';
export const PARAGRAPH_PRESET = 'paragraph-preset';
export const PARAGRAPH_PRESET_CATEGORY = 'paragraph-preset-category';
export const PARENT_CHILD = 'parent-child';
export const PEDIGREE = 'pedigree';
export const PERMISSIONS = 'permissions';
export const POLYP_RECORD = 'polyp-record';
export const PROBAND_METADATA = 'proband-metadata';
export const PROFILE = 'profile';
export const QUESTION_CATEGORY = 'question-category';
export const RACE_RECORD = 'race-record';
export const RECOVERY_BIN_RECORD = 'recovery-bin-record';
export const REPORT = 'report';
export const REPORT_TEMPLATE = 'report-template';
export const REPORT_TEMPLATE_CATEGORY = 'report-template-category';
export const REPRODUCTIVE_RECORD = 'reproductive-record';
export const RISK_RECORD = 'risk-record';
export const SHARED_SITE_INDIVIDUAL = 'shared-site-individual';
export const SITE = 'site';
export const SITE_FHQ = 'site-fhq';
export const SITE_FILES = 'site-files';
export const SPOUSE = 'spouse';
export const SPOUSE_CHILD = 'spouse-child';
export const SPREADSHEET_TEMPLATE = 'spreadsheet-template';
export const SPREADSHEET_TEMPLATE_CATEGORY = 'spreadsheet-template-category';
export const TEST = 'test';
export const TEST_ATTACHMENT = 'test-attachment';
export const TEST_GENE = 'test-gene';
export const TEST_TYPE = 'test-type';
export const TWINS = 'twins';
export const TWINSHIPS = 'twinships';
export const UPLOAD = 'upload';
export const USER = 'user';
export const USER_GROUPS = 'user-group';
